export const types = {
  OBJECT: 'OBJECT',
  LIST: 'LIST',
  NUMBER: 'NUMBER',
  STRING: 'STRING',
  BOOL: 'BOOL',
  DATE: 'DATE',
  SEGMENT: 'SEGMENT',
  JEXL: 'JEXL',
  COHORT: 'COHORT',
};

export const operators = {
  is_null: 'is_null',
  not_null: 'not_null',
  between: 'between',
  in: 'in',
  not_in: 'not_in',
  '=': '=',
  '!=': '!=',
  '>': '>',
  '>=': '>=',
  '<': '<',
  '<=': '<=',
  ANY: 'ANY',
  ALL: 'ALL',
  NONE: 'NONE',
  like_case_insensitive: 'like_case_insensitive',
  not_like_case_insensitive: 'not_like_case_insensitive',
  regexp: 'regexp',
  not_regexp: 'not_regexp',
};

export const likeOperators = [
  operators.like_case_insensitive,
  operators.not_like_case_insensitive,
  operators.regexp,
  operators.not_regexp,
];

export const numberOperators = [
  operators.in,
  operators.not_in,
  operators['='],
  operators['>'],
  operators['>='],
  operators['<'],
  operators['<='],
  operators.is_null,
  operators.not_null,
];

export const nullOperators = [operators.is_null, operators.not_null];

const numberDefaultOperator = numberOperators[0];

export const stringOperators = [
  operators.in,
  operators.not_in,
  operators.like_case_insensitive,
  operators.not_like_case_insensitive,
  operators.regexp,
  operators.not_regexp,
  operators.is_null,
  operators.not_null,
];

const stringDefaultOperator = stringOperators[0];

export const listOperators = [operators.ANY, operators.NONE, operators.ALL];

const listDefaultOperator = listOperators[0];

export const segmentOperators = [operators.ALL, operators.ANY, operators.NONE];

const segmentDefaultOperator = segmentOperators[0];

export const singleValuesOperators = [
  operators['='],
  operators['>'],
  operators['>='],
  operators['<'],
  operators['<='],
  operators.like_case_insensitive,
  operators.not_like_case_insensitive,
  operators.regexp,
  operators.not_regexp,
];

export const cohortOperators = [operators.in, operators.not_in];

const cohortDefaultOperator = cohortOperators[0];

export const dateOperators = [operators.between, operators.is_null, operators.not_null];

const dateDefaultOperator = dateOperators[0];

export const defaultTypeOperators = {
  [types.STRING]: stringDefaultOperator,
  [types.LIST]: listDefaultOperator,
  [types.NUMBER]: numberDefaultOperator,
  [types.DATE]: dateDefaultOperator,
  [types.SEGMENT]: segmentDefaultOperator,
  [types.COHORT]: cohortDefaultOperator,
};

export const concatOperators = {
  AND: '&&',
  OR: '||',
};

const constructFilterActions = (prefix) => ({
  ADD_FILTER_CLAUSE: `${prefix}ADD_FILTER_CLAUSE`,
  COPY_FILTER: `${prefix}COPY_FILTER`,
  REMOVE_FILTER: `${prefix}REMOVE_FILTER`,
  REMOVE_FILTER_CLAUSE: `${prefix}REMOVE_FILTER_CLAUSE`,
  SET_FILTER_CLAUSE_FIELD: `${prefix}SET_FILTER_CLAUSE_FIELD`,
  SET_FILTER_CLAUSE_VALUE: `${prefix}SET_FILTER_CLAUSE_VALUE`,
  SET_CLAUSES_CONCAT_OPERATOR: `${prefix}SET_CLAUSES_CONCAT_OPERATOR`,
  SET_FILTER_CLAUSE_OPERATOR: `${prefix}SET_FILTER_CLAUSE_OPERATOR`,
  SET_FILTER_VISIBILITY: `${prefix}SET_FILTER_VISIBILITY`,
});

export const globalFilterActionsPrefix = 'GLOBAL_FILTER_';

export const globalFilterActions = {
  ...constructFilterActions(globalFilterActionsPrefix),
  CHANGE_EVENT: `${globalFilterActionsPrefix}CHANGE_EVENT`,
};

export const funnelStepFilterActionsPrefix = 'UPDATE_FUNNEL_';

export const funnelStepFilterActions = constructFilterActions(funnelStepFilterActionsPrefix);

export const dashboardFunnelStepFilterActionsPrefix = 'DASHBOARD_UPDATE_FUNNEL_';

export const dashboardFunnelStepFilterActions = constructFilterActions(
  dashboardFunnelStepFilterActionsPrefix
);

export const segmentStepFilterActionsPrefix = 'UPDATE_SEGMENT_';

export const segmentStepFilterActions = constructFilterActions(segmentStepFilterActionsPrefix);

export const retentionEventFilterActionsPrefix = 'UPDATE_RETENTION_';

export const retentionEventFilterActions = constructFilterActions(
  retentionEventFilterActionsPrefix
);

export const dashboardRetentionEventFilterActionsPrefix = 'DASHBOARD_UPDATE_RETENTION_';

export const dashboardRetentionEventFilterActions = constructFilterActions(
  dashboardRetentionEventFilterActionsPrefix
);

export const eventsFilterActionsPrefix = 'EVENTS_COMPOSE_EVENT_';

export const eventsFilterActions = constructFilterActions(eventsFilterActionsPrefix);

export const dashboardEventsFilterActionsPrefix = 'DASHBOARD_EVENTS_COMPOSE_EVENT_';

export const dashboardEventsFilterActions = constructFilterActions(
  dashboardEventsFilterActionsPrefix
);

export const usersFilterActionsPrefix = 'USERS_COMPOSE_EVENT_';

export const usersFilterActions = constructFilterActions(usersFilterActionsPrefix);

export const dashboardUsersFilterActionsPrefix = 'DASHBOARD_USERS_COMPOSE_EVENT_';

export const dashboardUsersFilterActions = constructFilterActions(
  dashboardUsersFilterActionsPrefix
);

export const revenuePaymentFilterActionsPrefix = 'REVENUE_COMPOSE_PAYMENT_FILTER_';

export const revenuePaymentFilterActions = constructFilterActions(
  revenuePaymentFilterActionsPrefix
);

export const dashboardRevenuePaymentFilterActionsPrefix =
  'DASHBOARD_REVENUE_COMPOSE_PAYMENT_FILTER_';

export const dashboardRevenuePaymentFilterActions = constructFilterActions(
  dashboardRevenuePaymentFilterActionsPrefix
);
